import React from "react";
import TestsID from "../../../utils/TestsID";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import { Redirect, useHistory } from "react-router-dom";
import { distribution, POSA } from "../../../utils/routes/routes";
import { useDispatch, useSelector } from "react-redux";
import CheckoutFormOuter from "../../CheckoutForm/CheckoutFormOuter";
import {
  DEFAULT_POSA_ORDER,
  setModalPaymentProps
} from "../../../redux/saas/reducer";
import NiceModal from "@ebay/nice-modal-react";
import PostPaymentModal from "../../modal/ConfirmPayment/PostPaymentModal";
import type { RootStateI } from "../../../redux";
import { updatePOSAOrderThunk } from "../../../redux/saas/thunks";
import { setLoading } from "../../../redux/actions/app";
import { useUrlQuery } from "../../../utils/hooks/useUrlQuery";
import { FullScreenLoader } from "../../Loaders/FullScreenLoader/FullScreenLoader";
import { tt } from "../../../utils/i18n/i18n";
import { buildPathWithTrackingId } from "../../../utils/routing/routingUtils";

const SaasFlyersOrderPayment = () => {
  const { accountToDisplay } = useAccountToDisplaySelector();
  const history = useHistory();
  const dispatch = useDispatch();
  const query = useUrlQuery();

  const currentPOSAOrder = useSelector(
    (state: RootStateI) => state.saas.currentPOSAOrder
  );

  const billId = React.useMemo(() => {
    return query.get("billId");
  }, [query]);

  async function onFinished() {
    dispatch(
      setModalPaymentProps({
        isModalPostPaymentOpen: true
      })
    );
    dispatch(setLoading(false));

    const confirmed = await NiceModal.show(PostPaymentModal, {
      headerText: tt("payment_done_modal_title"),
      bodyText: tt("payment_done_modal_text"),
      buttonText: tt("payment_done_modal_button_text")
    });

    if (confirmed) {
      dispatch(updatePOSAOrderThunk(DEFAULT_POSA_ORDER));
      history.push(buildPathWithTrackingId(POSA, accountToDisplay?.trackingID));
    }
  }

  function handlePrev() {
    history.goBack();
  }

  if (!accountToDisplay?.trackingID) {
    return <FullScreenLoader loading={true} />;
  }

  if (!billId) {
    return <Redirect to={distribution} push={true} />;
  }

  return (
    <div id={TestsID.SAAS_FLYERS_ORDER_PAGE_PAYMENT_CONTAINER}>
      <CheckoutFormOuter
        businessUserId={accountToDisplay?.email}
        amount={currentPOSAOrder.totalPriceTTC || 0}
        posaDeliveryIds={
          currentPOSAOrder.billAndDelivery?.map((pd) => pd.id) || []
        }
        bill={currentPOSAOrder.billAndDelivery?.[0]?.bill}
        onFinished={onFinished}
        handlePrev={handlePrev}
        isSaasSubscriptionForm={false}
      />
    </div>
  );
};

export default SaasFlyersOrderPayment;
